// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".language-form .btn{width:100%}@media (max-width: 1199.98px){.language-form .btn{width:auto;float:right}}\n", ""]);
// Exports
module.exports = exports;
